function splitPhoneExtension(value: string) {
  const raw = String(value || "").trim();
  const hasPlusPrefix = raw.startsWith("+");
  const digits = raw.replace(/\D/g, "");

  if (!digits) {
    return { main: raw, extension: "" };
  }

  if (!hasPlusPrefix) {
    return { main: digits, extension: "" };
  }

  if (digits.length <= 10) {
    return { main: digits, extension: "" };
  }

  return {
    main: digits.slice(-10),
    extension: `${hasPlusPrefix ? "+" : ""}${digits.slice(0, -10)}`,
  };
}

function formatNationalTenDigits(digits: string) {
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

function formatBasePhoneNumber(value: string) {
  const raw = String(value || "").trim();
  const digits = raw.replace(/\D/g, "");

  if (!digits) {
    return raw;
  }

  if (digits.length === 10) {
    return formatNationalTenDigits(digits);
  }

  return raw;
}

export function formatPhoneNumber(value: string) {
  const raw = String(value || "").trim();
  if (!raw) return raw;

  const { main, extension } = splitPhoneExtension(raw);
  const formatted = formatBasePhoneNumber(main);

  if (!extension) {
    return formatted;
  }

  return `${extension} ${formatted}`;
}
